<template>
	<div class="sm:w-3/4 m-4">
		<header class="rounded-t-3xl py-4 border border-dark border-opacity-5 shadow-md">
			<span class="text-2xl text-alpha-blue-main font-semibold">Edge Fit</span>
		</header>

		<main class="flex flex-col items-center rounded-b-3xl py-12 border border-dark border-opacity-5 shadow-md">
			<h1 class="text-2xl mx-4 mb-12">We want to help sporters and personal coaches.</h1>

			<div class="w-full flex flex-col sm:flex-row items-center justify-evenly mb-20">
				<a class="mb-8 sm:mb-0 w-11/12 sm:w-5/12 flex justify-center transform transition-transform hover:scale-105 focus:scale-105" href="https://xd.adobe.com/view/5b6cfb62-7b17-4585-92f6-b5fe203b4572-0e3f/" target="_blank">
					<img :src="`${publicPath}img/mockups/workout-info.jpg`" alt="App design - Workout info" />
				</a>

				<a class="w-11/12 sm:w-5/12 flex justify-center transform transition-transform hover:scale-105 focus:scale-105" href="https://xd.adobe.com/view/5b6cfb62-7b17-4585-92f6-b5fe203b4572-0e3f/" target="_blank">
					<img :src="`${publicPath}img/mockups/workout.jpg`" alt="App design - Workout" />
				</a>
			</div>

			<div class="w-full flex flex-col items-center border border-dark border-opacity-5 py-12 mb-12">
				<p class="text-lg mb-8">We use Artificial Intelligence to recognize the sporter's posture and show feedback to improve it.</p>
				<img :src="`${publicPath}img/ai-examples/fitness-with-ai.jpg`" class="w-11/12 sm:w-3/4" alt="Fitness with AI" />
			</div>

			<div class="flex flex-col justify-evenly mb-8 py-4">
				<div class="mb-12">
					<h2 class="text-xl mb-8">Benefits for sporters.</h2>
					<div class="grid xl:grid-cols-3 mx-3 xl:mx-6">
						<div class="flex flex-col items-center justify-evenly p-6 mb-6 xl:mb-0 mx-6 rounded-lg border border-dark border-opacity-5 shadow-md">
							<p class="text-lg">Find the perfect personal trainer.</p>
							<svg class="w-1/2 xl:w-1/2 xl:w-1/3 mt-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#707070" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
								<circle cx="9" cy="7" r="4"></circle>
								<path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
								<path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
							</svg>
						</div>
						<div class="flex flex-col items-center justify-evenly p-6 mb-6 xl:mb-0 mx-6 rounded-lg border border-dark border-opacity-5 shadow-md">
							<p class="text-lg">Realtime feedback from your personal trainer.</p>
							<svg class="w-1/2 xl:w-1/2 xl:w-1/3 mt-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#707070" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>
						</div>
						<div class="flex flex-col items-center justify-evenly p-6 mb-6 xl:mb-0 mx-6 rounded-lg border border-dark border-opacity-5 shadow-md">
							<p class="text-lg">Do any workout you like.</p>
							<svg class="w-1/2 xl:w-1/2 xl:w-1/3 mt-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" preserveAspectRatio="xMidYMid meet">
								<g transform="translate(0,512) scale(0.100000,-0.100000)" fill="#707070" stroke="none">
									<path
										d="M1000 4143 c-29 -11 -66 -38 -106 -77 -79 -80 -94 -122 -94 -272 l0
										-113 -212 -3 c-244 -3 -255 -7 -339 -95 -92 -95 -84 1 -84 -1023 l0 -905 22
										-40 c26 -48 104 -126 153 -151 30 -16 64 -19 248 -22 l212 -3 0 -113 c0 -150
										15 -192 94 -272 93 -93 100 -94 466 -94 366 0 373 1 466 94 99 99 94 63 94
										753 l0 593 640 0 640 0 0 -593 c0 -690 -5 -654 94 -753 93 -93 100 -94 466
										-94 366 0 373 1 466 94 79 80 94 122 94 272 l0 113 213 3 c243 3 254 7 338 95
										92 95 84 -1 84 1023 0 1024 8 928 -84 1023 -84 88 -95 92 -338 95 l-213 3 0
										113 c0 150 -15 192 -94 272 -93 93 -100 94 -466 94 -366 0 -373 -1 -466 -94
										-99 -99 -94 -63 -94 -753 l0 -593 -640 0 -640 0 0 593 c0 690 5 654 -94 753
										-93 93 -99 94 -470 93 -257 0 -319 -3 -356 -16z m600 -1583 l0 -1280 -240 0
										-240 0 0 1280 0 1280 240 0 240 0 0 -1280z m2400 0 l0 -1280 -240 0 -240 0 0
										1280 0 1280 240 0 240 0 0 -1280z m-3200 0 l0 -800 -160 0 -160 0 0 800 0 800
										160 0 160 0 0 -800z m3840 0 l0 -800 -160 0 -160 0 0 800 0 800 160 0 160 0 0
										-800z"
									/>
								</g>
							</svg>
						</div>
					</div>
				</div>

				<div class="xl:mb-4">
					<h2 class="text-xl mb-8">Benefits for coaches.</h2>
					<div class="grid xl:grid-cols-3 mx-3 xl:mx-6">
						<div class="flex flex-col items-center justify-evenly p-6 mb-6 xl:mb-0 mx-6 rounded-lg border border-dark border-opacity-5 shadow-md">
							<p class="text-lg">Remote personal training.</p>
							<svg class="w-1/2 xl:w-1/2 xl:w-1/3 mt-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#707070" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
								<path d="M5 12.55a11 11 0 0 1 14.08 0"></path>
								<path d="M1.42 9a16 16 0 0 1 21.16 0"></path>
								<path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
								<line x1="12" y1="20" x2="12.01" y2="20"></line>
							</svg>
						</div>
						<div class="flex flex-col items-center justify-evenly p-6 mb-6 xl:mb-0 mx-6 rounded-lg border border-dark border-opacity-5 shadow-md">
							<p class="text-lg">Train as many sporters as you like.</p>
							<svg class="w-1/2 xl:w-1/2 xl:w-1/3 mt-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#707070">
								<path d="M0 0h24v24H0z" fill="none" />
								<path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
							</svg>
						</div>
						<div class="flex flex-col items-center justify-evenly p-6 mb-6 xl:mb-0 mx-6 rounded-lg border border-dark border-opacity-5 shadow-md">
							<p class="text-lg">Create custom training schedules for your clients.</p>
							<svg class="w-1/2 xl:w-1/2 xl:w-1/3 mt-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#707070">
								<path d="M0 0h24v24H0z" fill="none" />
								<path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z" />
							</svg>
						</div>
					</div>
				</div>
			</div>

			<div class="flex flex-col xl:flex-row items-center justify-evenly">
				<a class="shadow-md bg-alpha-blue-medium-normal text-white py-3 px-8 rounded-3xl hover:bg-alpha-blue-medium-hover focus:bg-alpha-blue-medium-focus transition-colors" href="https://forms.gle/sy4bRo45u9BNrt6m6" target="_blank">Vote for us!</a>
				<a class="mt-4 xl:mt-0 xl:ml-4 text-alpha-blue-medium-normal hover:text-alpha-blue-medium-hover focus:text-alpha-blue-medium-focus transition-colors" href="https://mct.be/the-collective/" target="_blank">Or view the other MCT projects</a>
			</div>
		</main>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
	setup() {
		return {
			publicPath: process.env.BASE_URL,
		};
	},
});
</script>
